import { Dispatch, MutableRefObject, ReactNode } from 'react';
import { SELECT_TYPE } from '@alf/uikit';
import { getThemesComponent } from '@namespace/themes';
import { IntentType } from '../../../../types';
import { SelectContent as DefaultSelectContent } from './SelectContent';

interface Option {
  value: string | number;
  title: string;
  label?: string;
  iconElement?: ReactNode;
  hasNtf?: boolean;
  ntf?: string;
}

interface CustomSelectContentProps {
  isCustomLanguageSelect?: boolean;
  value?: Option['value'];
  options?: Option[];
  size?: 'xs' | 's' | 'm';
  onClick: (option: Option) => void;
  onClose?: () => void;
  additionSelectContentStyle?: string;
  additionSelectTitleStyle?: string;
  additionSelectOptionStyle?: {
    item?: string;
    active?: string;
    activeTitle?: string;
  };
  intentType?: IntentType;
  selectType?: typeof SELECT_TYPE.ADDITIONAL;
  hasCheck?: boolean;
  emptyText?: string;
  setIsOpen: (open: boolean) => void;
  setSearchValue?: (value: string) => void;
  inputRef?: MutableRefObject<HTMLInputElement | null>;
  selectedItem: number;
  setSelectedItem: (index: number) => void;
  dataRole?: string;
  hasIcon?: boolean;
  setCurrentValue?: Dispatch<React.SetStateAction<string>>;
  searchValue?: string;
  isOpen?: boolean;
  isRegularHover?: boolean;
  dataTestId?: string;
}

export const SelectContent = ({
  isCustomLanguageSelect = false,
  ...restProps
}: CustomSelectContentProps) => {
  if (!isCustomLanguageSelect) {
    return <DefaultSelectContent {...restProps} />;
  }

  const Component = getThemesComponent(
    DefaultSelectContent,
    'LanguageSelectContent'
  );

  return <Component {...restProps} />;
};
